// Module
var code = `<div class="playlist-compose-stepper" title="{{ \$ctrl.disabled ? \$ctrl.disabledNote : '' }}">
  <button type="button" class="playlist-compose-step" ng-click="\$ctrl.down()"
    ng-disabled="\$ctrl.disabled || \$ctrl.atMin" aria-label="One less">
    <i class="fas fa-minus" aria-hidden="true"></i>
  </button>
  <span class="playlist-compose-number" ng-class="{ 'has-label': \$ctrl.label }">{{ \$ctrl.value }}<span
      ng-if="\$ctrl.label"> {{ \$ctrl.label }}</span></span>
  <button type="button" class="playlist-compose-step" ng-click="\$ctrl.up()"
    ng-disabled="\$ctrl.disabled || \$ctrl.atMax" aria-label="One more">
    <i class="fas fa-plus" aria-hidden="true"></i>
  </button>
</div>
`;
// Exports
export default code;